module.exports = __webpack_public_path__ + "img/black-diamond.e578d654.png";